import { Contents } from "./Contents"
import { Footer } from "./Footer"
import { Item } from "./Item"
import { Link } from "./Link"
import { Root } from "./Root"

export const NavigationMenu = {
  Item,
  Link,
  Contents,
  Footer,
  Root,
}
